import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="48"
      height="48"
      viewBox="0 0 175 175"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M87.5 175C135.825 175 175 135.825 175 87.5C175 39.1751 135.825 0 87.5 0C39.1751 0 0 39.1751 0 87.5C0 135.825 39.1751 175 87.5 175Z"
        fill="url(#paint0_radial_6152_23990)"
      />
      <path
        opacity="0.15"
        d="M87.5 175C135.825 175 175 135.825 175 87.5C175 39.1751 135.825 0 87.5 0C39.1751 0 0 39.1751 0 87.5C0 135.825 39.1751 175 87.5 175Z"
        fill="url(#paint1_radial_6152_23990)"
      />
      <path
        d="M87.5 175C135.825 175 175 135.825 175 87.5C175 39.1751 135.825 0 87.5 0C39.1751 0 0 39.1751 0 87.5C0 135.825 39.1751 175 87.5 175Z"
        fill="url(#paint2_radial_6152_23990)"
      />
      <path
        d="M87.5 138.078C59.6124 138.078 36.9236 115.389 36.9236 87.5C36.9236 59.6112 59.6129 36.923 87.5 36.923C115.387 36.923 138.076 59.6117 138.076 87.5C138.076 115.388 115.388 138.078 87.5 138.078Z"
        fill="#E3E3E3"
      />
      <path
        d="M87.5 136.11C60.6976 136.11 38.8916 114.303 38.8916 87.5C38.8916 60.697 60.6976 38.891 87.5 38.891C114.303 38.891 136.108 60.697 136.108 87.5C136.108 114.303 114.303 136.11 87.5 136.11Z"
        fill="#3C3C3B"
      />
      <path
        d="M87.5001 39.4841C61.0243 39.4841 39.4844 61.0242 39.4844 87.5005C39.4844 113.977 61.0243 135.517 87.5001 135.517C113.976 135.517 135.516 113.977 135.516 87.5005C135.516 61.0242 113.976 39.4841 87.5001 39.4841Z"
        fill="#E3E3E3"
      />
      <path
        d="M154.576 83.9402C154.789 83.6186 154.724 83.3948 154.372 83.2385C154.23 83.1761 154.115 83.1772 153.974 83.243C153.91 83.2733 153.858 83.3133 153.812 83.3684C153.572 83.6529 153.448 83.9734 153.327 84.313C153.026 85.1598 152.998 85.9178 153.236 86.7848C153.463 87.6041 154.061 88.2248 154.24 89.0733C154.434 89.9915 154.299 90.6966 153.779 91.4771C153.631 91.6992 153.643 91.8589 153.819 92.0579C154.359 92.6674 154.852 91.5969 155.026 91.1043C155.328 90.2569 155.356 89.4995 155.117 88.6325C154.891 87.8121 154.292 87.1919 154.114 86.3429C153.92 85.4252 154.057 84.7212 154.576 83.9402Z"
        fill="#575756"
      />
      <path
        d="M151.729 83.9402C151.942 83.6186 151.878 83.3948 151.525 83.2385C151.383 83.1761 151.268 83.1772 151.128 83.243C151.063 83.2733 151.011 83.3133 150.965 83.3684C150.726 83.6529 150.602 83.9734 150.481 84.313C150.179 85.1598 150.152 85.9178 150.39 86.7848C150.616 87.6041 151.215 88.2248 151.394 89.0733C151.587 89.9915 151.452 90.6966 150.933 91.4771C150.784 91.6992 150.796 91.8589 150.973 92.0579C151.512 92.6674 152.005 91.5969 152.18 91.1043C152.482 90.2569 152.509 89.4995 152.271 88.6325C152.045 87.8121 151.446 87.1919 151.267 86.3429C151.074 85.4252 151.211 84.7212 151.729 83.9402Z"
        fill="#575756"
      />
      <path
        d="M148.883 83.9402C149.096 83.6186 149.031 83.3948 148.678 83.2385C148.537 83.1761 148.422 83.1772 148.281 83.243C148.216 83.2733 148.165 83.3133 148.119 83.3684C147.879 83.6529 147.755 83.9734 147.634 84.313C147.332 85.1598 147.305 85.9178 147.543 86.7848C147.769 87.6041 148.368 88.2248 148.547 89.0733C148.74 89.9915 148.605 90.6966 148.086 91.4771C147.937 91.6992 147.95 91.8589 148.126 92.0579C148.666 92.6674 149.159 91.5969 149.333 91.1043C149.635 90.2569 149.663 89.4995 149.424 88.6325C149.198 87.8121 148.599 87.1919 148.42 86.3429C148.227 85.4252 148.364 84.7212 148.883 83.9402Z"
        fill="#575756"
      />
      <path
        d="M87.5 133.325C112.808 133.325 133.324 112.808 133.324 87.5005C133.324 62.1926 112.808 41.6765 87.5 41.6765C62.192 41.6765 41.676 62.1926 41.676 87.5005C41.676 112.808 62.192 133.325 87.5 133.325Z"
        fill="url(#paint3_linear_6152_23990)"
      />
      <path
        d="M87.5 133.325C112.808 133.325 133.324 112.808 133.324 87.5005C133.324 62.1926 112.808 41.6765 87.5 41.6765C62.192 41.6765 41.676 62.1926 41.676 87.5005C41.676 112.808 62.192 133.325 87.5 133.325Z"
        fill="url(#paint4_radial_6152_23990)"
      />
      <path
        d="M87.4999 129.737C110.827 129.737 129.737 110.827 129.737 87.5C129.737 64.1731 110.827 45.2628 87.4999 45.2628C64.1729 45.2628 45.2627 64.1731 45.2627 87.5C45.2627 110.827 64.1729 129.737 87.4999 129.737Z"
        fill="url(#paint5_radial_6152_23990)"
      />
      <path
        d="M87.5005 123.427C107.342 123.427 123.427 107.342 123.427 87.5C123.427 67.6583 107.342 51.5734 87.5005 51.5734C67.6588 51.5734 51.574 67.6583 51.574 87.5C51.574 107.342 67.6588 123.427 87.5005 123.427Z"
        fill="url(#paint6_radial_6152_23990)"
      />
      <path
        d="M87.5002 118.059C104.378 118.059 118.059 104.377 118.059 87.5C118.059 70.6227 104.378 56.9409 87.5002 56.9409C70.6229 56.9409 56.9412 70.6227 56.9412 87.5C56.9412 104.377 70.6229 118.059 87.5002 118.059Z"
        fill="url(#paint7_radial_6152_23990)"
      />
      <path
        d="M87.4999 92.9985C90.5367 92.9985 92.9986 90.5367 92.9986 87.4999C92.9986 84.4631 90.5367 82.0013 87.4999 82.0013C84.4632 82.0013 82.0015 84.4631 82.0015 87.4999C82.0015 90.5367 84.4632 92.9985 87.4999 92.9985Z"
        fill="#3C3C3B"
      />
      <path
        d="M73.7169 43.7896C73.2435 43.9386 72.7779 44.1011 72.3118 44.2652C72.458 44.3518 72.6267 44.4053 72.8088 44.4053C73.221 44.4053 73.5724 44.15 73.7169 43.7896Z"
        fill="#3C3C3B"
      />
      <path
        d="M75.748 44.4053C76.2884 44.4053 76.7275 43.9667 76.7275 43.4264C76.7275 43.2678 76.6865 43.1205 76.6196 42.9878C75.9988 43.139 75.3848 43.3049 74.7742 43.4815C74.8034 43.9954 75.2262 44.4053 75.748 44.4053Z"
        fill="#3C3C3B"
      />
      <path
        d="M77.7068 43.4259C77.7068 43.9662 78.1448 44.4048 78.6852 44.4048C79.2266 44.4048 79.6659 43.9662 79.6659 43.4259C79.6659 42.9755 79.36 42.6004 78.9456 42.4857C78.6633 42.5391 78.3798 42.5875 78.0993 42.6454C77.8631 42.8248 77.7068 43.1059 77.7068 43.4259Z"
        fill="#3C3C3B"
      />
      <path
        d="M81.6239 44.4048C82.1646 44.4048 82.6029 43.9665 82.6029 43.4259C82.6029 42.8852 82.1646 42.4469 81.6239 42.4469C81.0833 42.4469 80.645 42.8852 80.645 43.4259C80.645 43.9665 81.0833 44.4048 81.6239 44.4048Z"
        fill="#3C3C3B"
      />
      <path
        d="M84.5635 44.4054C85.1032 44.4054 85.5418 43.9668 85.5418 43.4264C85.5418 42.8855 85.1032 42.4469 84.5635 42.4469C84.0214 42.4469 83.584 42.8849 83.584 43.4264C83.5834 43.9668 84.0214 44.4054 84.5635 44.4054Z"
        fill="#3C3C3B"
      />
      <path
        d="M87.5009 44.4048C88.0415 44.4048 88.48 43.9665 88.48 43.4259C88.48 42.8852 88.0415 42.4469 87.5009 42.4469C86.9602 42.4469 86.522 42.8852 86.522 43.4259C86.522 43.9665 86.9602 44.4048 87.5009 44.4048Z"
        fill="#3C3C3B"
      />
      <path
        d="M90.4386 44.4048C90.9793 44.4048 91.4176 43.9665 91.4176 43.4259C91.4176 42.8852 90.9793 42.4469 90.4386 42.4469C89.898 42.4469 89.4597 42.8852 89.4597 43.4259C89.4597 43.9665 89.898 44.4048 90.4386 44.4048Z"
        fill="#3C3C3B"
      />
      <path
        d="M93.3778 44.4048C93.9185 44.4048 94.3568 43.9665 94.3568 43.4259C94.3568 42.8852 93.9185 42.4469 93.3778 42.4469C92.8372 42.4469 92.3989 42.8852 92.3989 43.4259C92.3989 43.9665 92.8372 44.4048 93.3778 44.4048Z"
        fill="#3C3C3B"
      />
      <path
        d="M95.3362 43.4259C95.3362 43.9662 95.7749 44.4048 96.3163 44.4048C96.8567 44.4048 97.2958 43.9662 97.2958 43.4259C97.2958 43.1059 97.1401 42.8248 96.9028 42.646C96.6222 42.5875 96.3382 42.5391 96.0559 42.4857C95.6421 42.601 95.3362 42.976 95.3362 43.4259Z"
        fill="#3C3C3B"
      />
      <path
        d="M99.2539 44.4053C99.7768 44.4053 100.199 43.9954 100.228 43.4815C99.6171 43.3055 99.0031 43.139 98.3823 42.9878C98.3154 43.1199 98.2744 43.2678 98.2744 43.4264C98.2744 43.9667 98.7141 44.4053 99.2539 44.4053Z"
        fill="#3C3C3B"
      />
      <path
        d="M102.193 44.4054C102.375 44.4054 102.543 44.352 102.689 44.2654C102.224 44.1018 101.758 43.9393 101.285 43.7903C101.43 44.1501 101.781 44.4054 102.193 44.4054Z"
        fill="#3C3C3B"
      />
      <path
        d="M66.9336 47.3432C67.474 47.3432 67.9131 46.9052 67.9131 46.3643C67.9131 46.2681 67.8952 46.177 67.8693 46.0887C67.2901 46.3637 66.72 46.6544 66.1543 46.9524C66.3337 47.1886 66.6142 47.3432 66.9336 47.3432Z"
        fill="#3C3C3B"
      />
      <path
        d="M69.8708 47.344C70.4118 47.344 70.8504 46.9055 70.8504 46.3645C70.8504 45.8235 70.4118 45.385 69.8708 45.385C69.3299 45.385 68.8914 45.8235 68.8914 46.3645C68.8914 46.9055 69.3299 47.344 69.8708 47.344Z"
        fill="#3C3C3B"
      />
      <path
        d="M72.8091 47.344C73.35 47.344 73.7885 46.9055 73.7885 46.3645C73.7885 45.8235 73.35 45.385 72.8091 45.385C72.2681 45.385 71.8296 45.8235 71.8296 46.3645C71.8296 46.9055 72.2681 47.344 72.8091 47.344Z"
        fill="#3C3C3B"
      />
      <path
        d="M76.7277 46.3651C76.7277 45.8236 76.2886 45.385 75.7483 45.385C75.2079 45.385 74.7688 45.8236 74.7688 46.3651C74.7688 46.6659 74.9071 46.9313 75.1208 47.1106C75.6341 46.9532 76.1531 46.807 76.6749 46.6693C76.7064 46.5731 76.7277 46.4713 76.7277 46.3651Z"
        fill="#3C3C3B"
      />
      <path
        d="M78.6852 45.385C78.1448 45.385 77.7068 45.8236 77.7068 46.3651C77.7068 46.3825 77.7113 46.3982 77.7119 46.4151C78.3354 46.2672 78.9641 46.1317 79.5978 46.012C79.4561 45.6453 79.1018 45.385 78.6852 45.385Z"
        fill="#3C3C3B"
      />
      <path
        d="M81.6236 45.385C81.2975 45.385 81.0102 45.5464 80.8325 45.7915C81.2958 45.7179 81.7637 45.6599 82.2315 45.6015C82.0639 45.4676 81.8547 45.385 81.6236 45.385Z"
        fill="#3C3C3B"
      />
      <path
        d="M93.3781 45.385C93.147 45.385 92.9383 45.4676 92.7708 45.6015C93.2386 45.6599 93.7059 45.7179 94.1686 45.7915C93.991 45.5458 93.7042 45.385 93.3781 45.385Z"
        fill="#3C3C3B"
      />
      <path
        d="M97.2961 46.3651C97.2961 45.8236 96.857 45.385 96.3166 45.385C95.9005 45.385 95.5468 45.6453 95.4045 46.012C96.0388 46.1317 96.6669 46.2672 97.2904 46.4156C97.2916 46.3982 97.2961 46.3819 97.2961 46.3651Z"
        fill="#3C3C3B"
      />
      <path
        d="M100.234 46.3651C100.234 45.8236 99.7959 45.385 99.2544 45.385C98.714 45.385 98.2749 45.8236 98.2749 46.3651C98.2749 46.4719 98.2963 46.5731 98.3283 46.6698C98.8507 46.8076 99.369 46.9538 99.883 47.1112C100.096 46.9307 100.234 46.6653 100.234 46.3651Z"
        fill="#3C3C3B"
      />
      <path
        d="M102.193 47.344C102.734 47.344 103.172 46.9055 103.172 46.3645C103.172 45.8235 102.734 45.385 102.193 45.385C101.652 45.385 101.213 45.8235 101.213 46.3645C101.213 46.9055 101.652 47.344 102.193 47.344Z"
        fill="#3C3C3B"
      />
      <path
        d="M105.131 47.344C105.672 47.344 106.111 46.9055 106.111 46.3645C106.111 45.8235 105.672 45.385 105.131 45.385C104.59 45.385 104.152 45.8235 104.152 46.3645C104.152 46.9055 104.59 47.344 105.131 47.344Z"
        fill="#3C3C3B"
      />
      <path
        d="M108.068 47.3433C108.388 47.3433 108.668 47.1887 108.847 46.9531C108.282 46.6551 107.713 46.3649 107.134 46.09C107.108 46.1777 107.09 46.2688 107.09 46.3649C107.09 46.9053 107.528 47.3433 108.068 47.3433Z"
        fill="#3C3C3B"
      />
      <path
        d="M62.025 49.4097C61.619 49.6818 61.2231 49.9675 60.8262 50.252C60.9004 50.27 60.9768 50.2823 61.0561 50.2823C61.561 50.2823 61.971 49.9 62.025 49.4097Z"
        fill="#3C3C3B"
      />
      <path
        d="M63.0149 49.3021C63.0149 49.8431 63.454 50.2822 63.9944 50.2822C64.5347 50.2822 64.9733 49.8436 64.9733 49.3021C64.9733 48.7618 64.5347 48.3226 63.9944 48.3226C63.8229 48.3226 63.6649 48.3704 63.5249 48.448C63.485 48.4728 63.4456 48.4992 63.4057 48.5245C63.1701 48.7033 63.0149 48.9833 63.0149 49.3021Z"
        fill="#3C3C3B"
      />
      <path
        d="M66.9336 50.2816C67.4745 50.2816 67.913 49.8431 67.913 49.3021C67.913 48.7612 67.4745 48.3226 66.9336 48.3226C66.3926 48.3226 65.9541 48.7612 65.9541 49.3021C65.9541 49.8431 66.3926 50.2816 66.9336 50.2816Z"
        fill="#3C3C3B"
      />
      <path
        d="M69.8709 48.3226C69.33 48.3226 68.8926 48.7618 68.8926 49.3021C68.8926 49.3921 68.9084 49.477 68.9309 49.5597C69.5067 49.2774 70.0909 49.0092 70.6818 48.7522C70.5058 48.493 70.2083 48.3226 69.8709 48.3226Z"
        fill="#3C3C3B"
      />
      <path
        d="M106.111 49.3021C106.111 48.7618 105.671 48.3226 105.131 48.3226C104.793 48.3226 104.496 48.493 104.32 48.7528C104.911 49.0098 105.495 49.2779 106.072 49.5602C106.094 49.4776 106.111 49.3921 106.111 49.3021Z"
        fill="#3C3C3B"
      />
      <path
        d="M108.068 50.2816C108.609 50.2816 109.048 49.8431 109.048 49.3021C109.048 48.7612 108.609 48.3226 108.068 48.3226C107.527 48.3226 107.089 48.7612 107.089 49.3021C107.089 49.8431 107.527 50.2816 108.068 50.2816Z"
        fill="#3C3C3B"
      />
      <path
        d="M110.029 49.3021C110.029 49.8431 110.466 50.2822 111.007 50.2822C111.548 50.2822 111.986 49.8436 111.986 49.3021C111.986 48.9833 111.831 48.7027 111.595 48.5234C111.556 48.4992 111.517 48.4728 111.477 48.448C111.337 48.3704 111.179 48.3226 111.007 48.3226C110.466 48.3226 110.029 48.7618 110.029 49.3021Z"
        fill="#3C3C3B"
      />
      <path
        d="M113.946 50.2822C114.026 50.2822 114.102 50.2705 114.176 50.2519C113.779 49.9674 113.384 49.6817 112.978 49.4102C113.032 49.8999 113.442 50.2822 113.946 50.2822Z"
        fill="#3C3C3B"
      />
      <path
        d="M59.0976 52.2407C59.0976 52.036 59.0341 51.846 58.9267 51.6891C58.419 52.0945 57.9214 52.5117 57.4316 52.9385C57.6082 53.1128 57.8505 53.2202 58.1182 53.2202C58.6585 53.2196 59.0976 52.7816 59.0976 52.2407Z"
        fill="#3C3C3B"
      />
      <path
        d="M61.0561 53.2202C61.5971 53.2202 62.0357 52.7817 62.0357 52.2407C62.0357 51.6998 61.5971 51.2612 61.0561 51.2612C60.5152 51.2612 60.0767 51.6998 60.0767 52.2407C60.0767 52.7817 60.5152 53.2202 61.0561 53.2202Z"
        fill="#3C3C3B"
      />
      <path
        d="M63.9944 51.2612C63.454 51.2612 63.0149 51.6998 63.0149 52.2407C63.0149 52.4988 63.1172 52.7316 63.2797 52.9065C63.806 52.5376 64.3407 52.1811 64.8845 51.8359C64.7293 51.4974 64.3902 51.2612 63.9944 51.2612Z"
        fill="#3C3C3B"
      />
      <path
        d="M111.986 52.2407C111.986 51.6998 111.548 51.2612 111.007 51.2612C110.611 51.2612 110.272 51.4974 110.118 51.8359C110.662 52.1811 111.196 52.5376 111.722 52.9065C111.885 52.731 111.986 52.4988 111.986 52.2407Z"
        fill="#3C3C3B"
      />
      <path
        d="M113.946 53.2202C114.487 53.2202 114.925 52.7817 114.925 52.2407C114.925 51.6998 114.487 51.2612 113.946 51.2612C113.405 51.2612 112.966 51.6998 112.966 52.2407C112.966 52.7817 113.405 53.2202 113.946 53.2202Z"
        fill="#3C3C3B"
      />
      <path
        d="M116.883 53.2198C117.151 53.2198 117.393 53.1124 117.571 52.9381C117.081 52.5113 116.583 52.0947 116.075 51.6887C115.968 51.8456 115.904 52.0356 115.904 52.2403C115.904 52.7818 116.343 53.2198 116.883 53.2198Z"
        fill="#3C3C3B"
      />
      <path
        d="M55.1805 56.1588C55.7209 56.1588 56.1589 55.7202 56.1589 55.1793C56.1589 54.8751 56.0178 54.6074 55.8007 54.4275C55.334 54.8756 54.8758 55.3333 54.4282 55.8006C54.6082 56.0176 54.8763 56.1588 55.1805 56.1588Z"
        fill="#3C3C3B"
      />
      <path
        d="M58.1181 56.1588C58.6591 56.1588 59.0976 55.7203 59.0976 55.1793C59.0976 54.6384 58.6591 54.1998 58.1181 54.1998C57.5772 54.1998 57.1387 54.6384 57.1387 55.1793C57.1387 55.7203 57.5772 56.1588 58.1181 56.1588Z"
        fill="#3C3C3B"
      />
      <path
        d="M61.0561 54.1998C60.5158 54.1998 60.0767 54.6384 60.0767 55.1799C60.0767 55.2462 60.0835 55.3109 60.0964 55.3739C60.5356 54.9988 60.9826 54.6339 61.4375 54.2768C61.3205 54.2268 61.1911 54.1998 61.0561 54.1998Z"
        fill="#3C3C3B"
      />
      <path
        d="M114.926 55.1793C114.926 54.6384 114.487 54.1992 113.946 54.1992C113.811 54.1992 113.682 54.2268 113.565 54.2763C114.02 54.6333 114.467 54.9982 114.906 55.3733C114.919 55.3109 114.926 55.2457 114.926 55.1793Z"
        fill="#3C3C3B"
      />
      <path
        d="M116.883 56.1588C117.425 56.1588 117.864 55.7202 117.864 55.1793C117.864 54.6384 117.425 54.1992 116.883 54.1992C116.343 54.1992 115.904 54.6378 115.904 55.1793C115.904 55.7202 116.343 56.1588 116.883 56.1588Z"
        fill="#3C3C3B"
      />
      <path
        d="M118.843 55.1793C118.843 55.7197 119.281 56.1588 119.821 56.1588C120.125 56.1588 120.393 56.0177 120.573 55.8007C120.125 55.3334 119.668 54.8757 119.201 54.4281C118.984 54.6075 118.843 54.8757 118.843 55.1793Z"
        fill="#3C3C3B"
      />
      <path
        d="M53.2201 58.1171C53.2201 57.8494 53.1128 57.6071 52.939 57.4305C52.5117 57.9203 52.0949 58.4179 51.689 58.9262C51.8458 59.0336 52.0359 59.0971 52.2405 59.0971C52.7831 59.0971 53.2201 58.658 53.2201 58.1171Z"
        fill="#3C3C3B"
      />
      <path
        d="M55.1808 59.0973C55.7211 59.0973 56.1591 58.6587 56.1591 58.1178C56.1591 57.5769 55.7211 57.1383 55.1808 57.1383C54.6387 57.1383 54.2002 57.5769 54.2002 58.1178C54.2002 58.6587 54.6387 59.0973 55.1808 59.0973Z"
        fill="#3C3C3B"
      />
      <path
        d="M58.1514 57.1417C58.1396 57.1417 58.1294 57.1383 58.1182 57.1383C57.5778 57.1383 57.1382 57.5769 57.1382 58.1178C57.1382 58.1296 57.1409 58.1397 57.1415 58.1515C57.4727 57.8086 57.8084 57.4723 58.1514 57.1417Z"
        fill="#3C3C3B"
      />
      <path
        d="M117.86 58.1509C117.861 58.1391 117.864 58.129 117.864 58.1172C117.864 57.5763 117.425 57.1377 116.883 57.1377C116.872 57.1377 116.862 57.1405 116.85 57.1411C117.193 57.4722 117.529 57.8085 117.86 58.1509Z"
        fill="#3C3C3B"
      />
      <path
        d="M119.822 59.0973C120.363 59.0973 120.801 58.6588 120.801 58.1178C120.801 57.5768 120.363 57.1383 119.822 57.1383C119.281 57.1383 118.842 57.5768 118.842 58.1178C118.842 58.6588 119.281 59.0973 119.822 59.0973Z"
        fill="#3C3C3B"
      />
      <path
        d="M122.76 59.0971C122.965 59.0971 123.155 59.0335 123.312 58.9261C122.906 58.4184 122.489 57.9208 122.063 57.431C121.888 57.6076 121.781 57.8499 121.781 58.1176C121.782 58.6579 122.22 59.0971 122.76 59.0971Z"
        fill="#3C3C3B"
      />
      <path
        d="M50.2828 61.0556C50.2828 60.9758 50.271 60.8993 50.2524 60.8251C49.9679 61.2215 49.6822 61.6174 49.4106 62.0233C49.9004 61.9699 50.2828 61.5594 50.2828 61.0556Z"
        fill="#3C3C3B"
      />
      <path
        d="M52.2409 62.0345C52.7815 62.0345 53.2199 61.5963 53.2199 61.0556C53.2199 60.515 52.7815 60.0767 52.2409 60.0767C51.7002 60.0767 51.262 60.515 51.262 61.0556C51.262 61.5963 51.7002 62.0345 52.2409 62.0345Z"
        fill="#3C3C3B"
      />
      <path
        d="M55.1808 60.0762C54.6387 60.0762 54.2002 60.5148 54.2002 61.0557C54.2002 61.1906 54.2277 61.3194 54.2772 61.4363C54.6343 60.982 54.9991 60.5344 55.3742 60.0953C55.3112 60.0829 55.2466 60.0762 55.1808 60.0762Z"
        fill="#3C3C3B"
      />
      <path
        d="M120.802 61.0557C120.802 60.5148 120.364 60.0762 119.822 60.0762C119.756 60.0762 119.691 60.0829 119.628 60.0958C120.003 60.535 120.368 60.9826 120.725 61.4369C120.775 61.3199 120.802 61.1912 120.802 61.0557Z"
        fill="#3C3C3B"
      />
      <path
        d="M122.761 62.0345C123.301 62.0345 123.74 61.5963 123.74 61.0556C123.74 60.515 123.301 60.0767 122.761 60.0767C122.22 60.0767 121.782 60.515 121.782 61.0556C121.782 61.5963 122.22 62.0345 122.761 62.0345Z"
        fill="#3C3C3B"
      />
      <path
        d="M125.591 62.0239C125.32 61.6179 125.034 61.2227 124.75 60.8257C124.732 60.8999 124.719 60.9764 124.719 61.0562C124.72 61.5595 125.102 61.9694 125.591 62.0239Z"
        fill="#3C3C3B"
      />
      <path
        d="M49.3033 64.9737C49.8442 64.9737 50.2827 64.5352 50.2827 63.9942C50.2827 63.4533 49.8442 63.0148 49.3033 63.0148C48.985 63.0148 48.705 63.1688 48.5256 63.4044C48.5003 63.4455 48.4728 63.4848 48.448 63.5253C48.371 63.6653 48.3232 63.8233 48.3232 63.9942C48.3232 64.5346 48.7623 64.9737 49.3033 64.9737Z"
        fill="#3C3C3B"
      />
      <path
        d="M52.2409 63.0148C51.7 63.0148 51.262 63.4533 51.262 63.9942C51.262 64.3901 51.4981 64.7297 51.8361 64.8838C52.1813 64.3406 52.5378 63.8059 52.9067 63.2796C52.7324 63.1165 52.4995 63.0148 52.2409 63.0148Z"
        fill="#3C3C3B"
      />
      <path
        d="M123.74 63.9942C123.74 63.4533 123.3 63.0148 122.761 63.0148C122.503 63.0148 122.269 63.1165 122.094 63.2802C122.463 63.8059 122.82 64.3406 123.165 64.8838C123.503 64.7292 123.74 64.3901 123.74 63.9942Z"
        fill="#3C3C3B"
      />
      <path
        d="M125.699 63.0148C125.159 63.0148 124.72 63.4533 124.72 63.9942C124.72 64.5346 125.159 64.9737 125.699 64.9737C126.24 64.9737 126.679 64.5352 126.679 63.9942C126.679 63.8227 126.631 63.6647 126.553 63.5242C126.529 63.4842 126.502 63.4455 126.477 63.4055C126.298 63.1694 126.017 63.0148 125.699 63.0148Z"
        fill="#3C3C3B"
      />
      <path
        d="M47.344 66.9322C47.344 66.6134 47.1895 66.3328 46.9539 66.1534C46.6553 66.7191 46.3646 67.2887 46.0896 67.8679C46.1773 67.8937 46.2684 67.9117 46.3646 67.9117C46.9055 67.9117 47.344 67.4731 47.344 66.9322Z"
        fill="#3C3C3B"
      />
      <path
        d="M49.3032 67.9115C49.8442 67.9115 50.2827 67.473 50.2827 66.932C50.2827 66.3911 49.8442 65.9525 49.3032 65.9525C48.7622 65.9525 48.3237 66.3911 48.3237 66.932C48.3237 67.473 48.7622 67.9115 49.3032 67.9115Z"
        fill="#3C3C3B"
      />
      <path
        d="M125.699 67.9115C126.24 67.9115 126.679 67.473 126.679 66.932C126.679 66.3911 126.24 65.9525 125.699 65.9525C125.158 65.9525 124.72 66.3911 124.72 66.932C124.72 67.473 125.158 67.9115 125.699 67.9115Z"
        fill="#3C3C3B"
      />
      <path
        d="M127.658 66.9323C127.658 67.4732 128.096 67.9118 128.637 67.9118C128.733 67.9118 128.824 67.8938 128.912 67.8679C128.637 67.2888 128.346 66.7191 128.048 66.1541C127.813 66.3329 127.658 66.6135 127.658 66.9323Z"
        fill="#3C3C3B"
      />
      <path
        d="M46.3647 70.8501C46.9057 70.8501 47.3442 70.4116 47.3442 69.8706C47.3442 69.3297 46.9057 68.8911 46.3647 68.8911C45.8238 68.8911 45.3853 69.3297 45.3853 69.8706C45.3853 70.4116 45.8238 70.8501 46.3647 70.8501Z"
        fill="#3C3C3B"
      />
      <path
        d="M49.3032 68.8911C48.7623 68.8911 48.3237 69.3297 48.3237 69.8712C48.3237 70.2085 48.4946 70.5054 48.7544 70.682C49.0113 70.091 49.2796 69.5068 49.5618 68.9305C49.4786 68.9069 49.3932 68.8911 49.3032 68.8911Z"
        fill="#3C3C3B"
      />
      <path
        d="M126.679 69.8707C126.679 69.3292 126.24 68.8906 125.699 68.8906C125.609 68.8906 125.523 68.9064 125.441 68.9294C125.723 69.5052 125.992 70.09 126.249 70.681C126.508 70.5055 126.679 70.2075 126.679 69.8707Z"
        fill="#3C3C3B"
      />
      <path
        d="M128.637 70.8501C129.178 70.8501 129.616 70.4116 129.616 69.8706C129.616 69.3297 129.178 68.8911 128.637 68.8911C128.096 68.8911 127.657 69.3297 127.657 69.8706C127.657 70.4116 128.096 70.8501 128.637 70.8501Z"
        fill="#3C3C3B"
      />
      <path
        d="M44.406 72.8087C44.406 72.6259 44.3526 72.4572 44.2655 72.311C44.1018 72.7772 43.9394 73.2439 43.7898 73.7167C44.1502 73.5728 44.406 73.2214 44.406 72.8087Z"
        fill="#3C3C3B"
      />
      <path
        d="M46.3647 73.7887C46.9057 73.7887 47.3442 73.3501 47.3442 72.8092C47.3442 72.2682 46.9057 71.8297 46.3647 71.8297C45.8238 71.8297 45.3853 72.2682 45.3853 72.8092C45.3853 73.3501 45.8238 73.7887 46.3647 73.7887Z"
        fill="#3C3C3B"
      />
      <path
        d="M128.637 73.7887C129.178 73.7887 129.616 73.3501 129.616 72.8092C129.616 72.2682 129.178 71.8297 128.637 71.8297C128.096 71.8297 127.657 72.2682 127.657 72.8092C127.657 73.3501 128.096 73.7887 128.637 73.7887Z"
        fill="#3C3C3B"
      />
      <path
        d="M131.212 73.7172C131.062 73.2444 130.9 72.7777 130.736 72.3115C130.649 72.4577 130.596 72.6269 130.596 72.8091C130.597 73.2213 130.851 73.5722 131.212 73.7172Z"
        fill="#3C3C3B"
      />
      <path
        d="M44.4063 75.7469C44.4063 75.2251 43.9964 74.8023 43.4814 74.7731C43.3054 75.3832 43.1395 75.9977 42.9883 76.6185C43.1199 76.6854 43.2682 76.7265 43.4262 76.7265C43.9677 76.7265 44.4063 76.2879 44.4063 75.7469Z"
        fill="#3C3C3B"
      />
      <path
        d="M46.3647 74.7676C45.8237 74.7676 45.3857 75.2062 45.3857 75.7471C45.3857 76.2874 45.8237 76.7266 46.3647 76.7266C46.4715 76.7266 46.5738 76.7052 46.6705 76.6732C46.8083 76.1519 46.954 75.6335 47.1114 75.1201C46.9321 74.9065 46.6655 74.7676 46.3647 74.7676Z"
        fill="#3C3C3B"
      />
      <path
        d="M128.637 76.7266C129.178 76.7266 129.616 76.288 129.616 75.7471C129.616 75.2062 129.178 74.7676 128.637 74.7676C128.336 74.7676 128.07 74.9065 127.891 75.1201C128.048 75.6335 128.194 76.1514 128.331 76.6726C128.428 76.7052 128.529 76.7266 128.637 76.7266Z"
        fill="#3C3C3B"
      />
      <path
        d="M130.596 75.747C130.596 76.2874 131.034 76.7265 131.576 76.7265C131.735 76.7265 131.882 76.6855 132.013 76.6185C131.862 75.9978 131.696 75.3838 131.52 74.7737C131.005 74.8024 130.596 75.2252 130.596 75.747Z"
        fill="#3C3C3B"
      />
      <path
        d="M43.4262 79.6652C43.9676 79.6652 44.4058 79.2266 44.4058 78.6857C44.4058 78.1448 43.9676 77.7062 43.4262 77.7062C43.1068 77.7062 42.8251 77.8619 42.6457 78.0992C42.5873 78.3798 42.5395 78.6637 42.4861 78.946C42.6014 79.3598 42.9763 79.6652 43.4262 79.6652Z"
        fill="#3C3C3B"
      />
      <path
        d="M46.3647 77.7062C45.8237 77.7062 45.3857 78.1448 45.3857 78.6857C45.3857 79.1018 45.6466 79.4554 46.0127 79.5971C46.133 78.9634 46.2685 78.3348 46.417 77.7112C46.399 77.7101 46.3827 77.7062 46.3647 77.7062Z"
        fill="#3C3C3B"
      />
      <path
        d="M129.616 78.6857C129.616 78.1448 129.178 77.7062 128.637 77.7062C128.62 77.7062 128.603 77.7101 128.585 77.7112C128.734 78.3348 128.869 78.9634 128.989 79.5971C129.355 79.4554 129.616 79.1018 129.616 78.6857Z"
        fill="#3C3C3B"
      />
      <path
        d="M131.576 77.7062C131.034 77.7062 130.596 78.1448 130.596 78.6857C130.596 79.226 131.034 79.6652 131.576 79.6652C132.026 79.6652 132.401 79.3587 132.516 78.9443C132.462 78.6632 132.414 78.3798 132.356 78.1009C132.177 77.8625 131.896 77.7062 131.576 77.7062Z"
        fill="#3C3C3B"
      />
      <path
        d="M43.426 82.6035C43.967 82.6035 44.4056 82.165 44.4056 81.624C44.4056 81.0831 43.967 80.6445 43.426 80.6445C42.885 80.6445 42.4465 81.0831 42.4465 81.624C42.4465 82.165 42.885 82.6035 43.426 82.6035Z"
        fill="#3C3C3B"
      />
      <path
        d="M45.3857 81.6241C45.3857 81.8546 45.469 82.0644 45.6028 82.2319C45.6613 81.7635 45.7192 81.2952 45.7929 80.8324C45.5472 81.0101 45.3857 81.2974 45.3857 81.6241Z"
        fill="#3C3C3B"
      />
      <path
        d="M129.616 81.6241C129.616 81.2974 129.455 81.0106 129.209 80.8324C129.283 81.2957 129.341 81.7635 129.4 82.2313C129.533 82.0638 129.616 81.8546 129.616 81.6241Z"
        fill="#3C3C3B"
      />
      <path
        d="M131.576 82.6035C132.116 82.6035 132.554 82.165 132.554 81.624C132.554 81.0831 132.116 80.6445 131.576 80.6445C131.034 80.6445 130.596 81.0831 130.596 81.624C130.596 82.1644 131.034 82.6035 131.576 82.6035Z"
        fill="#3C3C3B"
      />
      <path
        d="M43.426 85.5415C43.967 85.5415 44.4056 85.103 44.4056 84.562C44.4056 84.0211 43.967 83.5825 43.426 83.5825C42.885 83.5825 42.4465 84.0211 42.4465 84.562C42.4465 85.103 42.885 85.5415 43.426 85.5415Z"
        fill="#3C3C3B"
      />
      <path
        d="M131.576 85.5415C132.117 85.5415 132.556 85.103 132.556 84.562C132.556 84.0211 132.117 83.5825 131.576 83.5825C131.035 83.5825 130.596 84.0211 130.596 84.562C130.596 85.103 131.035 85.5415 131.576 85.5415Z"
        fill="#3C3C3B"
      />
      <path
        d="M43.426 88.4801C43.967 88.4801 44.4056 88.0416 44.4056 87.5006C44.4056 86.9597 43.967 86.5211 43.426 86.5211C42.885 86.5211 42.4465 86.9597 42.4465 87.5006C42.4465 88.0416 42.885 88.4801 43.426 88.4801Z"
        fill="#3C3C3B"
      />
      <path
        d="M131.576 88.4801C132.117 88.4801 132.556 88.0416 132.556 87.5006C132.556 86.9597 132.117 86.5211 131.576 86.5211C131.035 86.5211 130.596 86.9597 130.596 87.5006C130.596 88.0416 131.035 88.4801 131.576 88.4801Z"
        fill="#3C3C3B"
      />
      <path
        d="M43.426 91.4186C43.967 91.4186 44.4056 90.9801 44.4056 90.4391C44.4056 89.8981 43.967 89.4596 43.426 89.4596C42.885 89.4596 42.4465 89.8981 42.4465 90.4391C42.4465 90.9801 42.885 91.4186 43.426 91.4186Z"
        fill="#3C3C3B"
      />
      <path
        d="M131.576 91.4186C132.117 91.4186 132.556 90.9801 132.556 90.4391C132.556 89.8981 132.117 89.4596 131.576 89.4596C131.035 89.4596 130.596 89.8981 130.596 90.4391C130.596 90.9801 131.035 91.4186 131.576 91.4186Z"
        fill="#3C3C3B"
      />
      <path
        d="M43.426 94.3563C43.967 94.3563 44.4056 93.9178 44.4056 93.3768C44.4056 92.8359 43.967 92.3973 43.426 92.3973C42.885 92.3973 42.4465 92.8359 42.4465 93.3768C42.4465 93.9178 42.885 94.3563 43.426 94.3563Z"
        fill="#3C3C3B"
      />
      <path
        d="M45.3857 93.3764C45.3857 93.7031 45.5472 93.991 45.7929 94.1686C45.7198 93.7053 45.6613 93.2369 45.6028 92.7686C45.469 92.9367 45.3857 93.1458 45.3857 93.3764Z"
        fill="#3C3C3B"
      />
      <path
        d="M129.616 93.3765C129.616 93.146 129.533 92.9368 129.4 92.7693C129.341 93.2377 129.283 93.7055 129.209 94.1688C129.455 93.9905 129.616 93.7032 129.616 93.3765Z"
        fill="#3C3C3B"
      />
      <path
        d="M131.576 94.3563C132.117 94.3563 132.556 93.9178 132.556 93.3768C132.556 92.8359 132.117 92.3973 131.576 92.3973C131.035 92.3973 130.596 92.8359 130.596 93.3768C130.596 93.9178 131.035 94.3563 131.576 94.3563Z"
        fill="#3C3C3B"
      />
      <path
        d="M43.4262 97.2951C43.9676 97.2951 44.4058 96.8565 44.4058 96.3156C44.4058 95.7752 43.9676 95.3361 43.4262 95.3361C42.9758 95.3361 42.6008 95.6414 42.4861 96.0546C42.5395 96.3369 42.5878 96.6214 42.6463 96.902C42.8251 97.1393 43.1068 97.2951 43.4262 97.2951Z"
        fill="#3C3C3B"
      />
      <path
        d="M45.3857 96.3149C45.3857 96.8558 45.8237 97.2944 46.3647 97.2944C46.3827 97.2944 46.3995 97.2905 46.417 97.2893C46.2685 96.6658 46.1336 96.0371 46.0132 95.4034C45.6472 95.5451 45.3857 95.8988 45.3857 96.3149Z"
        fill="#3C3C3B"
      />
      <path
        d="M128.636 97.295C129.178 97.295 129.615 96.8565 129.615 96.3155C129.615 95.8994 129.354 95.5457 128.988 95.4041C128.868 96.0377 128.733 96.6658 128.585 97.29C128.603 97.2905 128.619 97.295 128.636 97.295Z"
        fill="#3C3C3B"
      />
      <path
        d="M131.576 95.3361C131.034 95.3361 130.596 95.7746 130.596 96.3156C130.596 96.8565 131.034 97.2951 131.576 97.2951C131.896 97.2951 132.177 97.1387 132.356 96.9009C132.414 96.6214 132.462 96.338 132.515 96.0569C132.401 95.6425 132.026 95.3361 131.576 95.3361Z"
        fill="#3C3C3B"
      />
      <path
        d="M44.4063 99.2539C44.4063 98.713 43.9683 98.2744 43.4268 98.2744C43.2688 98.2744 43.1209 98.3155 42.9888 98.3824C43.14 99.0031 43.3059 99.6172 43.4824 100.228C43.9969 100.198 44.4063 99.7757 44.4063 99.2539Z"
        fill="#3C3C3B"
      />
      <path
        d="M46.3647 98.2738C45.8237 98.2738 45.3857 98.7124 45.3857 99.2533C45.3857 99.7942 45.8237 100.233 46.3647 100.233C46.666 100.233 46.9321 100.094 47.1114 99.8802C46.9546 99.3669 46.8083 98.849 46.6705 98.3272C46.5738 98.2952 46.4721 98.2738 46.3647 98.2738Z"
        fill="#3C3C3B"
      />
      <path
        d="M128.637 100.233C129.178 100.233 129.616 99.7942 129.616 99.2533C129.616 98.7124 129.178 98.2738 128.637 98.2738C128.529 98.2738 128.428 98.2952 128.331 98.3272C128.194 98.8485 128.048 99.3669 127.891 99.8797C128.071 100.094 128.336 100.233 128.637 100.233Z"
        fill="#3C3C3B"
      />
      <path
        d="M130.596 99.2539C130.596 99.7757 131.005 100.198 131.521 100.227C131.697 99.6172 131.863 99.0026 132.014 98.3824C131.882 98.3155 131.735 98.2744 131.577 98.2744C131.034 98.2739 130.596 98.713 130.596 99.2539Z"
        fill="#3C3C3B"
      />
      <path
        d="M43.7898 101.284C43.9394 101.757 44.1018 102.223 44.266 102.69C44.3526 102.543 44.406 102.374 44.406 102.192C44.406 101.78 44.1508 101.428 43.7898 101.284Z"
        fill="#3C3C3B"
      />
      <path
        d="M46.3647 103.172C46.9057 103.172 47.3442 102.733 47.3442 102.192C47.3442 101.651 46.9057 101.213 46.3647 101.213C45.8238 101.213 45.3853 101.651 45.3853 102.192C45.3853 102.733 45.8238 103.172 46.3647 103.172Z"
        fill="#3C3C3B"
      />
      <path
        d="M128.637 103.172C129.178 103.172 129.616 102.733 129.616 102.192C129.616 101.651 129.178 101.213 128.637 101.213C128.096 101.213 127.657 101.651 127.657 102.192C127.657 102.733 128.096 103.172 128.637 103.172Z"
        fill="#3C3C3B"
      />
      <path
        d="M130.596 102.192C130.596 102.375 130.65 102.543 130.736 102.689C130.9 102.223 131.063 101.757 131.212 101.284C130.851 101.429 130.596 101.78 130.596 102.192Z"
        fill="#3C3C3B"
      />
      <path
        d="M46.3647 106.109C46.9057 106.109 47.3442 105.671 47.3442 105.13C47.3442 104.589 46.9057 104.15 46.3647 104.15C45.8238 104.15 45.3853 104.589 45.3853 105.13C45.3853 105.671 45.8238 106.109 46.3647 106.109Z"
        fill="#3C3C3B"
      />
      <path
        d="M48.3232 105.13C48.3232 105.671 48.7618 106.109 49.3027 106.109C49.3927 106.109 49.4787 106.094 49.5608 106.071C49.2785 105.494 49.0103 104.91 48.7533 104.319C48.4941 104.495 48.3232 104.792 48.3232 105.13Z"
        fill="#3C3C3B"
      />
      <path
        d="M125.699 106.109C126.24 106.109 126.679 105.671 126.679 105.13C126.679 104.792 126.508 104.496 126.248 104.319C125.991 104.909 125.723 105.494 125.441 106.07C125.523 106.094 125.609 106.109 125.699 106.109Z"
        fill="#3C3C3B"
      />
      <path
        d="M128.637 106.109C129.178 106.109 129.616 105.671 129.616 105.13C129.616 104.589 129.178 104.15 128.637 104.15C128.096 104.15 127.657 104.589 127.657 105.13C127.657 105.671 128.096 106.109 128.637 106.109Z"
        fill="#3C3C3B"
      />
      <path
        d="M47.344 108.068C47.344 107.527 46.9055 107.089 46.3646 107.089C46.2684 107.089 46.1773 107.107 46.0896 107.133C46.3651 107.711 46.6553 108.281 46.9539 108.847C47.1895 108.668 47.344 108.387 47.344 108.068Z"
        fill="#3C3C3B"
      />
      <path
        d="M49.3032 109.048C49.8442 109.048 50.2827 108.609 50.2827 108.068C50.2827 107.527 49.8442 107.089 49.3032 107.089C48.7622 107.089 48.3237 107.527 48.3237 108.068C48.3237 108.609 48.7622 109.048 49.3032 109.048Z"
        fill="#3C3C3B"
      />
      <path
        d="M125.699 109.048C126.24 109.048 126.679 108.609 126.679 108.068C126.679 107.527 126.24 107.089 125.699 107.089C125.158 107.089 124.72 107.527 124.72 108.068C124.72 108.609 125.158 109.048 125.699 109.048Z"
        fill="#3C3C3B"
      />
      <path
        d="M127.658 108.068C127.658 108.387 127.813 108.667 128.048 108.847C128.346 108.281 128.637 107.711 128.912 107.133C128.824 107.107 128.733 107.089 128.637 107.089C128.096 107.089 127.658 107.527 127.658 108.068Z"
        fill="#3C3C3B"
      />
      <path
        d="M49.3032 111.986C49.8441 111.986 50.2827 111.548 50.2827 111.006C50.2827 110.466 49.8441 110.027 49.3032 110.027C48.7623 110.027 48.3237 110.465 48.3237 111.006C48.3237 111.176 48.371 111.334 48.4469 111.473C48.4733 111.515 48.5013 111.556 48.5272 111.598C48.7054 111.833 48.9855 111.986 49.3032 111.986Z"
        fill="#3C3C3B"
      />
      <path
        d="M51.262 111.006C51.262 111.547 51.7 111.986 52.2409 111.986C52.4995 111.986 52.7324 111.885 52.9072 111.721C52.5384 111.195 52.1818 110.66 51.8366 110.116C51.4981 110.271 51.262 110.61 51.262 111.006Z"
        fill="#3C3C3B"
      />
      <path
        d="M122.761 111.986C123.3 111.986 123.74 111.548 123.74 111.006C123.74 110.61 123.503 110.271 123.166 110.117C122.82 110.66 122.464 111.195 122.095 111.721C122.269 111.884 122.502 111.986 122.761 111.986Z"
        fill="#3C3C3B"
      />
      <path
        d="M125.699 110.027C125.159 110.027 124.72 110.466 124.72 111.007C124.72 111.548 125.159 111.987 125.699 111.987C126.016 111.987 126.297 111.833 126.476 111.598C126.502 111.556 126.53 111.516 126.556 111.474C126.632 111.335 126.679 111.177 126.679 111.007C126.679 110.466 126.24 110.027 125.699 110.027Z"
        fill="#3C3C3B"
      />
      <path
        d="M49.4106 112.977C49.6828 113.383 49.9679 113.779 50.253 114.175C50.2704 114.101 50.2828 114.024 50.2828 113.945C50.2828 113.441 49.9004 113.031 49.4106 112.977Z"
        fill="#3C3C3B"
      />
      <path
        d="M52.2409 114.924C52.7815 114.924 53.2199 114.486 53.2199 113.945C53.2199 113.405 52.7815 112.966 52.2409 112.966C51.7002 112.966 51.262 113.405 51.262 113.945C51.262 114.486 51.7002 114.924 52.2409 114.924Z"
        fill="#3C3C3B"
      />
      <path
        d="M54.2002 113.945C54.2002 114.486 54.6387 114.924 55.1808 114.924C55.2471 114.924 55.3112 114.918 55.3742 114.905C54.9997 114.466 54.6343 114.018 54.2772 113.564C54.2272 113.681 54.2002 113.809 54.2002 113.945Z"
        fill="#3C3C3B"
      />
      <path
        d="M119.822 114.924C120.364 114.924 120.802 114.486 120.802 113.945C120.802 113.809 120.775 113.681 120.725 113.564C120.368 114.018 120.003 114.466 119.628 114.905C119.691 114.918 119.755 114.924 119.822 114.924Z"
        fill="#3C3C3B"
      />
      <path
        d="M122.761 114.924C123.301 114.924 123.74 114.486 123.74 113.945C123.74 113.405 123.301 112.966 122.761 112.966C122.22 112.966 121.782 113.405 121.782 113.945C121.782 114.486 122.22 114.924 122.761 114.924Z"
        fill="#3C3C3B"
      />
      <path
        d="M124.72 113.945C124.72 114.025 124.732 114.101 124.75 114.175C125.035 113.778 125.32 113.383 125.592 112.977C125.102 113.031 124.72 113.441 124.72 113.945Z"
        fill="#3C3C3B"
      />
      <path
        d="M52.241 115.904C52.0364 115.904 51.8469 115.967 51.6895 116.075C52.096 116.582 52.5127 117.08 52.9395 117.57C53.1132 117.393 53.2206 117.151 53.2206 116.883C53.2201 116.342 52.7831 115.904 52.241 115.904Z"
        fill="#3C3C3B"
      />
      <path
        d="M55.1806 117.863C55.7216 117.863 56.1602 117.424 56.1602 116.883C56.1602 116.342 55.7216 115.904 55.1806 115.904C54.6397 115.904 54.2012 116.342 54.2012 116.883C54.2012 117.424 54.6397 117.863 55.1806 117.863Z"
        fill="#3C3C3B"
      />
      <path
        d="M57.1415 116.85C57.1409 116.861 57.1382 116.872 57.1382 116.883C57.1382 117.424 57.5778 117.863 58.1182 117.863C58.1294 117.863 58.1402 117.86 58.1514 117.859C57.8084 117.529 57.4727 117.192 57.1415 116.85Z"
        fill="#3C3C3B"
      />
      <path
        d="M116.85 117.859C116.862 117.859 116.872 117.863 116.883 117.863C117.425 117.863 117.864 117.425 117.864 116.883C117.864 116.872 117.861 116.861 117.86 116.85C117.529 117.192 117.193 117.529 116.85 117.859Z"
        fill="#3C3C3B"
      />
      <path
        d="M119.822 115.904C119.281 115.904 118.844 116.342 118.844 116.883C118.844 117.424 119.281 117.863 119.822 117.863C120.364 117.863 120.802 117.425 120.802 116.883C120.802 116.342 120.363 115.904 119.822 115.904Z"
        fill="#3C3C3B"
      />
      <path
        d="M121.782 116.883C121.782 117.151 121.889 117.393 122.063 117.57C122.49 117.08 122.906 116.582 123.312 116.075C123.155 115.967 122.966 115.904 122.761 115.904C122.22 115.904 121.782 116.342 121.782 116.883Z"
        fill="#3C3C3B"
      />
      <path
        d="M56.1589 119.821C56.1589 119.281 55.7209 118.842 55.1805 118.842C54.8763 118.842 54.6082 118.983 54.4282 119.2C54.8764 119.667 55.334 120.125 55.8013 120.573C56.0183 120.393 56.1589 120.125 56.1589 119.821Z"
        fill="#3C3C3B"
      />
      <path
        d="M58.1181 120.801C58.6591 120.801 59.0976 120.363 59.0976 119.822C59.0976 119.281 58.6591 118.842 58.1181 118.842C57.5772 118.842 57.1387 119.281 57.1387 119.822C57.1387 120.363 57.5772 120.801 58.1181 120.801Z"
        fill="#3C3C3B"
      />
      <path
        d="M60.0767 119.821C60.0767 120.363 60.5158 120.801 61.0561 120.801C61.1911 120.801 61.3205 120.774 61.4375 120.724C60.9832 120.367 60.5356 120.002 60.0964 119.627C60.0829 119.69 60.0767 119.755 60.0767 119.821Z"
        fill="#3C3C3B"
      />
      <path
        d="M113.946 120.801C114.486 120.801 114.926 120.363 114.926 119.821C114.926 119.754 114.919 119.69 114.906 119.627C114.467 120.002 114.02 120.367 113.565 120.724C113.682 120.774 113.811 120.801 113.946 120.801Z"
        fill="#3C3C3B"
      />
      <path
        d="M116.883 120.801C117.424 120.801 117.863 120.363 117.863 119.822C117.863 119.281 117.424 118.842 116.883 118.842C116.342 118.842 115.904 119.281 115.904 119.822C115.904 120.363 116.342 120.801 116.883 120.801Z"
        fill="#3C3C3B"
      />
      <path
        d="M119.822 118.842C119.281 118.842 118.844 119.28 118.844 119.821C118.844 120.125 118.985 120.393 119.202 120.573C119.668 120.124 120.127 119.667 120.574 119.2C120.394 118.983 120.126 118.842 119.822 118.842Z"
        fill="#3C3C3B"
      />
      <path
        d="M58.1182 121.78C57.8505 121.78 57.6088 121.888 57.4316 122.063C57.9214 122.489 58.419 122.906 58.9267 123.312C59.0336 123.154 59.0976 122.965 59.0976 122.76C59.0976 122.219 58.6585 121.78 58.1182 121.78Z"
        fill="#3C3C3B"
      />
      <path
        d="M61.0561 123.739C61.5971 123.739 62.0357 123.301 62.0357 122.76C62.0357 122.219 61.5971 121.78 61.0561 121.78C60.5152 121.78 60.0767 122.219 60.0767 122.76C60.0767 123.301 60.5152 123.739 61.0561 123.739Z"
        fill="#3C3C3B"
      />
      <path
        d="M63.0149 122.76C63.0149 123.301 63.454 123.739 63.9944 123.739C64.3896 123.739 64.7293 123.503 64.8839 123.165C64.3402 122.819 63.8054 122.463 63.2797 122.094C63.1172 122.269 63.0149 122.502 63.0149 122.76Z"
        fill="#3C3C3B"
      />
      <path
        d="M111.007 123.739C111.548 123.739 111.986 123.301 111.986 122.76C111.986 122.502 111.885 122.269 111.722 122.094C111.196 122.463 110.661 122.819 110.118 123.165C110.272 123.503 110.611 123.739 111.007 123.739Z"
        fill="#3C3C3B"
      />
      <path
        d="M113.946 123.739C114.487 123.739 114.925 123.301 114.925 122.76C114.925 122.219 114.487 121.78 113.946 121.78C113.405 121.78 112.966 122.219 112.966 122.76C112.966 123.301 113.405 123.739 113.946 123.739Z"
        fill="#3C3C3B"
      />
      <path
        d="M115.904 122.76C115.904 122.964 115.968 123.155 116.075 123.311C116.583 122.905 117.081 122.489 117.571 122.062C117.394 121.888 117.152 121.78 116.883 121.78C116.343 121.78 115.904 122.219 115.904 122.76Z"
        fill="#3C3C3B"
      />
      <path
        d="M61.0558 124.719C60.9765 124.719 60.9006 124.73 60.8264 124.748C61.2228 125.033 61.6187 125.319 62.0247 125.591C61.9707 125.101 61.5607 124.719 61.0558 124.719Z"
        fill="#3C3C3B"
      />
      <path
        d="M64.974 125.698C64.974 125.157 64.5355 124.719 63.9951 124.719C63.4547 124.719 63.0156 125.157 63.0156 125.698C63.0156 126.017 63.1708 126.298 63.4075 126.477C63.4458 126.501 63.4835 126.526 63.5223 126.551C63.6634 126.629 63.8225 126.678 63.9951 126.678C64.5349 126.678 64.974 126.238 64.974 125.698Z"
        fill="#3C3C3B"
      />
      <path
        d="M66.9336 126.678C67.4745 126.678 67.913 126.239 67.913 125.698C67.913 125.157 67.4745 124.719 66.9336 124.719C66.3926 124.719 65.9541 125.157 65.9541 125.698C65.9541 126.239 66.3926 126.678 66.9336 126.678Z"
        fill="#3C3C3B"
      />
      <path
        d="M68.8921 125.698C68.8921 126.239 69.3295 126.677 69.8705 126.677C70.2084 126.677 70.5059 126.506 70.6814 126.247C70.091 125.991 69.5062 125.722 68.9304 125.44C68.9085 125.523 68.8921 125.608 68.8921 125.698Z"
        fill="#3C3C3B"
      />
      <path
        d="M105.131 126.678C105.671 126.678 106.111 126.239 106.111 125.699C106.111 125.609 106.095 125.523 106.072 125.441C105.495 125.723 104.911 125.991 104.32 126.248C104.496 126.507 104.793 126.678 105.131 126.678Z"
        fill="#3C3C3B"
      />
      <path
        d="M108.068 124.719C107.528 124.719 107.09 125.157 107.09 125.698C107.09 126.238 107.528 126.677 108.068 126.677C108.61 126.677 109.049 126.238 109.049 125.698C109.049 125.157 108.61 124.719 108.068 124.719Z"
        fill="#3C3C3B"
      />
      <path
        d="M111.986 125.698C111.986 125.157 111.548 124.719 111.007 124.719C110.466 124.719 110.029 125.157 110.029 125.698C110.029 126.238 110.466 126.677 111.007 126.677C111.18 126.677 111.34 126.628 111.481 126.55C111.519 126.526 111.556 126.501 111.594 126.477C111.831 126.299 111.986 126.018 111.986 125.698Z"
        fill="#3C3C3B"
      />
      <path
        d="M112.978 125.591C113.384 125.319 113.779 125.033 114.176 124.748C114.102 124.731 114.025 124.719 113.946 124.719C113.441 124.719 113.032 125.101 112.978 125.591Z"
        fill="#3C3C3B"
      />
      <path
        d="M66.9336 127.657C66.6142 127.657 66.3337 127.811 66.1543 128.048C66.72 128.346 67.2901 128.636 67.8693 128.912C67.8952 128.824 67.9131 128.733 67.9131 128.636C67.9131 128.096 67.474 127.657 66.9336 127.657Z"
        fill="#3C3C3B"
      />
      <path
        d="M69.8709 127.657C69.33 127.657 68.8926 128.096 68.8926 128.636C68.8926 129.178 69.33 129.616 69.8709 129.616C70.413 129.616 70.8511 129.178 70.8511 128.636C70.8511 128.096 70.413 127.657 69.8709 127.657Z"
        fill="#3C3C3B"
      />
      <path
        d="M72.8091 129.616C73.35 129.616 73.7885 129.177 73.7885 128.636C73.7885 128.095 73.35 127.657 72.8091 127.657C72.2681 127.657 71.8296 128.095 71.8296 128.636C71.8296 129.177 72.2681 129.616 72.8091 129.616Z"
        fill="#3C3C3B"
      />
      <path
        d="M74.7688 128.636C74.7688 129.178 75.2079 129.616 75.7483 129.616C76.2886 129.616 76.7277 129.178 76.7277 128.636C76.7277 128.529 76.7064 128.428 76.6738 128.331C76.1525 128.194 75.6341 128.048 75.1208 127.891C74.9077 128.069 74.7688 128.335 74.7688 128.636Z"
        fill="#3C3C3B"
      />
      <path
        d="M77.7068 128.636C77.7068 129.178 78.1448 129.616 78.6852 129.616C79.1018 129.616 79.4561 129.355 79.5978 128.989C78.9641 128.869 78.3354 128.733 77.7119 128.586C77.7113 128.602 77.7068 128.619 77.7068 128.636Z"
        fill="#3C3C3B"
      />
      <path
        d="M81.6237 129.616C81.8548 129.616 82.0646 129.533 82.2321 129.399C81.7637 129.341 81.2954 129.283 80.832 129.209C81.0097 129.454 81.297 129.616 81.6237 129.616Z"
        fill="#3C3C3B"
      />
      <path
        d="M93.3781 129.616C93.7048 129.616 93.9916 129.454 94.1693 129.209C93.7059 129.283 93.2381 129.341 92.7703 129.399C92.9373 129.533 93.147 129.616 93.3781 129.616Z"
        fill="#3C3C3B"
      />
      <path
        d="M96.3166 129.616C96.857 129.616 97.2961 129.178 97.2961 128.636C97.2961 128.619 97.2916 128.602 97.2904 128.584C96.6669 128.733 96.0382 128.868 95.4045 128.989C95.5462 129.355 95.9 129.616 96.3166 129.616Z"
        fill="#3C3C3B"
      />
      <path
        d="M98.2744 128.636C98.2744 129.178 98.7135 129.616 99.2539 129.616C99.7954 129.616 100.233 129.178 100.233 128.636C100.233 128.335 100.095 128.069 99.8814 127.891C99.368 128.048 98.8496 128.194 98.3278 128.331C98.2958 128.428 98.2744 128.529 98.2744 128.636Z"
        fill="#3C3C3B"
      />
      <path
        d="M102.193 129.616C102.734 129.616 103.172 129.177 103.172 128.636C103.172 128.095 102.734 127.657 102.193 127.657C101.652 127.657 101.213 128.095 101.213 128.636C101.213 129.177 101.652 129.616 102.193 129.616Z"
        fill="#3C3C3B"
      />
      <path
        d="M105.131 127.657C104.59 127.657 104.151 128.096 104.151 128.636C104.151 129.178 104.59 129.616 105.131 129.616C105.671 129.616 106.111 129.178 106.111 128.636C106.111 128.096 105.671 127.657 105.131 127.657Z"
        fill="#3C3C3B"
      />
      <path
        d="M108.068 127.657C107.528 127.657 107.09 128.096 107.09 128.636C107.09 128.733 107.108 128.824 107.134 128.911C107.712 128.636 108.282 128.346 108.847 128.048C108.669 127.811 108.388 127.657 108.068 127.657Z"
        fill="#3C3C3B"
      />
      <path
        d="M72.8088 130.595C72.6267 130.595 72.458 130.649 72.3118 130.735C72.7779 130.899 73.2435 131.062 73.7169 131.21C73.5724 130.85 73.221 130.595 72.8088 130.595Z"
        fill="#3C3C3B"
      />
      <path
        d="M75.748 130.595C75.2262 130.595 74.8034 131.005 74.7742 131.52C75.3848 131.696 75.9994 131.862 76.6196 132.013C76.6865 131.881 76.7275 131.733 76.7275 131.575C76.7275 131.034 76.2884 130.595 75.748 130.595Z"
        fill="#3C3C3B"
      />
      <path
        d="M79.6666 131.575C79.6666 131.034 79.2274 130.595 78.6859 130.595C78.1455 130.595 77.7075 131.034 77.7075 131.575C77.7075 131.894 77.8633 132.176 78.1 132.355C78.3806 132.413 78.664 132.461 78.9463 132.515C79.3607 132.4 79.6666 132.025 79.6666 131.575Z"
        fill="#3C3C3B"
      />
      <path
        d="M81.6238 132.554C82.1647 132.554 82.6032 132.116 82.6032 131.575C82.6032 131.034 82.1647 130.595 81.6238 130.595C81.0828 130.595 80.6443 131.034 80.6443 131.575C80.6443 132.116 81.0828 132.554 81.6238 132.554Z"
        fill="#3C3C3B"
      />
      <path
        d="M84.5635 132.554C85.1044 132.554 85.5429 132.116 85.5429 131.575C85.5429 131.034 85.1044 130.595 84.5635 130.595C84.0225 130.595 83.584 131.034 83.584 131.575C83.584 132.116 84.0225 132.554 84.5635 132.554Z"
        fill="#3C3C3B"
      />
      <path
        d="M87.501 132.554C88.0419 132.554 88.4806 132.116 88.4806 131.575C88.4806 131.034 88.0419 130.595 87.501 130.595C86.96 130.595 86.5215 131.034 86.5215 131.575C86.5215 132.116 86.96 132.554 87.501 132.554Z"
        fill="#3C3C3B"
      />
      <path
        d="M90.4387 132.554C90.9797 132.554 91.4182 132.116 91.4182 131.575C91.4182 131.034 90.9797 130.595 90.4387 130.595C89.8977 130.595 89.4592 131.034 89.4592 131.575C89.4592 132.116 89.8977 132.554 90.4387 132.554Z"
        fill="#3C3C3B"
      />
      <path
        d="M93.3779 132.554C93.9189 132.554 94.3574 132.116 94.3574 131.575C94.3574 131.034 93.9189 130.595 93.3779 130.595C92.8369 130.595 92.3984 131.034 92.3984 131.575C92.3984 132.116 92.8369 132.554 93.3779 132.554Z"
        fill="#3C3C3B"
      />
      <path
        d="M97.2958 131.575C97.2958 131.034 96.8567 130.595 96.3163 130.595C95.7749 130.595 95.3362 131.034 95.3362 131.575C95.3362 132.025 95.6421 132.4 96.0559 132.515C96.3382 132.461 96.6222 132.413 96.9028 132.355C97.1401 132.176 97.2958 131.895 97.2958 131.575Z"
        fill="#3C3C3B"
      />
      <path
        d="M99.2539 130.595C98.7135 130.595 98.2744 131.034 98.2744 131.575C98.2744 131.733 98.3154 131.881 98.3823 132.013C99.0031 131.861 99.6171 131.696 100.228 131.519C100.198 131.005 99.7768 130.595 99.2539 130.595Z"
        fill="#3C3C3B"
      />
      <path
        d="M101.285 131.21C101.758 131.062 102.224 130.899 102.689 130.736C102.543 130.649 102.375 130.595 102.193 130.595C101.781 130.595 101.43 130.85 101.285 131.21Z"
        fill="#3C3C3B"
      />
      <defs>
        <radialGradient
          id="paint0_radial_6152_23990"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(87.5001 87.5001) scale(87.5003)"
        >
          <stop offset="0.5396" stopColor="#575756" />
          <stop offset="0.549" stopColor="#787877" stopOpacity="0.9969" />
          <stop offset="0.5608" stopColor="#979796" stopOpacity="0.9931" />
          <stop offset="0.5737" stopColor="#B0B0B0" stopOpacity="0.9889" />
          <stop offset="0.5878" stopColor="#C3C3C3" stopOpacity="0.9843" />
          <stop offset="0.6037" stopColor="#D2D2D2" stopOpacity="0.9791" />
          <stop offset="0.6223" stopColor="#DCDCDC" stopOpacity="0.9731" />
          <stop offset="0.6461" stopColor="#E2E2E2" stopOpacity="0.9654" />
          <stop offset="0.6931" stopColor="#E3E3E3" stopOpacity="0.9501" />
          <stop offset="0.7723" stopColor="#E3E3E3" stopOpacity="0.95" />
          <stop offset="1" stopColor="#E3E3E3" stopOpacity="0.95" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_6152_23990"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(87.5001 87.5001) scale(87.5003)"
        >
          <stop offset="0.8168" stopColor="white" stopOpacity="0" />
          <stop offset="0.8182" stopColor="#F8F8F8" stopOpacity="0.01" />
          <stop offset="0.8256" stopColor="#D7D7D7" stopOpacity="0.0453" />
          <stop offset="0.8339" stopColor="#B5B5B5" stopOpacity="0.0884" />
          <stop offset="0.8428" stopColor="#969695" stopOpacity="0.1348" />
          <stop offset="0.8526" stopColor="#797978" stopOpacity="0.1853" />
          <stop offset="0.8633" stopColor="#605F5F" stopOpacity="0.2411" />
          <stop offset="0.8754" stopColor="#494948" stopOpacity="0.304" />
          <stop offset="0.8896" stopColor="#373736" stopOpacity="0.3776" />
          <stop offset="0.9072" stopColor="#1E1D1D" stopOpacity="0.4684" />
          <stop offset="0.9317" stopColor="#070707" stopOpacity="0.596" />
          <stop offset="1" stopOpacity="0.95" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_6152_23990"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(87.5001 87.5001) scale(87.5003)"
        >
          <stop stopOpacity="0" />
          <stop offset="0.321" stopColor="#070707" stopOpacity="0.0745" />
          <stop offset="0.4366" stopColor="#1E1D1D" stopOpacity="0.1014" />
          <stop offset="0.5191" stopColor="#373736" stopOpacity="0.1205" />
          <stop offset="0.5857" stopColor="#494948" stopOpacity="0.136" />
          <stop offset="0.6428" stopColor="#605F5F" stopOpacity="0.1493" />
          <stop offset="0.6934" stopColor="#797978" stopOpacity="0.161" />
          <stop offset="0.7392" stopColor="#969695" stopOpacity="0.1716" />
          <stop offset="0.7812" stopColor="#B5B5B5" stopOpacity="0.1814" />
          <stop offset="0.8203" stopColor="#D7D7D7" stopOpacity="0.1905" />
          <stop offset="0.855" stopColor="#F8F8F8" stopOpacity="0.1985" />
          <stop offset="0.8614" stopColor="white" stopOpacity="0.2" />
          <stop offset="0.8846" stopColor="#CECECE" stopOpacity="0.1664" />
          <stop offset="0.9075" stopColor="#A0A0A0" stopOpacity="0.1334" />
          <stop offset="0.9294" stopColor="#777776" stopOpacity="0.1018" />
          <stop offset="0.9501" stopColor="#545453" stopOpacity="0.072" />
          <stop offset="0.9693" stopColor="#383837" stopOpacity="0.0443" />
          <stop offset="0.9865" stopColor="#151514" stopOpacity="0.0194" />
          <stop offset="1" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint3_linear_6152_23990"
          x1="55.0977"
          y1="55.0976"
          x2="119.903"
          y2="119.903"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BDBCBC" />
          <stop offset="0.0744" stopColor="#BABAB9" />
          <stop offset="0.1382" stopColor="#B1B1B1" />
          <stop offset="0.1981" stopColor="#A3A2A2" />
          <stop offset="0.2553" stopColor="#8E8E8D" />
          <stop offset="0.2921" stopColor="#7C7C7B" />
          <stop offset="0.505" stopColor="white" />
          <stop offset="0.5099" stopColor="#F1F1F1" />
          <stop offset="0.703" stopColor="#878787" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <radialGradient
          id="paint4_radial_6152_23990"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(87.5002 87.5002) rotate(45) scale(45.8239)"
        >
          <stop />
          <stop offset="0.1452" stopColor="#0D0D0D" stopOpacity="0.848" />
          <stop offset="0.2686" stopColor="#2A2A29" stopOpacity="0.7189" />
          <stop offset="0.384" stopColor="#434242" stopOpacity="0.5981" />
          <stop offset="0.4946" stopColor="#5C5C5B" stopOpacity="0.4824" />
          <stop offset="0.6017" stopColor="#7B7A7A" stopOpacity="0.3702" />
          <stop offset="0.7063" stopColor="#9D9D9C" stopOpacity="0.2608" />
          <stop offset="0.8088" stopColor="#C3C3C2" stopOpacity="0.1535" />
          <stop offset="0.9072" stopColor="#EAEAEA" stopOpacity="0.0505" />
          <stop offset="0.9554" stopColor="white" stopOpacity="0" />
          <stop offset="0.9631" stopColor="#FDFDFD" stopOpacity="0.1719" />
          <stop offset="0.969" stopColor="#F6F6F6" stopOpacity="0.3034" />
          <stop offset="0.9742" stopColor="#EAEAEA" stopOpacity="0.4217" />
          <stop offset="0.9792" stopColor="#D9D9D9" stopOpacity="0.5321" />
          <stop offset="0.9838" stopColor="#C2C2C2" stopOpacity="0.637" />
          <stop offset="0.9883" stopColor="#A4A4A4" stopOpacity="0.7379" />
          <stop offset="0.9927" stopColor="#7F7F7E" stopOpacity="0.8355" />
          <stop offset="0.9968" stopColor="#504F4F" stopOpacity="0.9282" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_6152_23990"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(87.5 87.4998) scale(42.2376)"
        >
          <stop stopColor="#F0F0F0" stopOpacity="0.95" />
          <stop offset="1" stopColor="#E3E3E3" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_6152_23990"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(87.5006 87.5001) scale(35.9264)"
        >
          <stop offset="0.8218" stopColor="#9D9D9C" />
          <stop offset="0.8349" stopColor="#A1A1A0" />
          <stop offset="0.8492" stopColor="#ACACAB" />
          <stop offset="0.8641" stopColor="#BDBDBD" />
          <stop offset="0.8663" stopColor="#C0C0C0" />
          <stop offset="0.9374" stopColor="#BFBFBF" />
          <stop offset="0.963" stopColor="#BABAB9" />
          <stop offset="0.9813" stopColor="#B0B0B0" />
          <stop offset="0.996" stopColor="#A2A2A2" />
          <stop offset="1" stopColor="#9D9D9C" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_6152_23990"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(87.5004 87.5004) scale(30.559)"
        >
          <stop stopColor="#F0F0F0" stopOpacity="0.95" />
          <stop offset="1" stopColor="#E3E3E3" />
        </radialGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
